import AnalyticsApi from 'utils/AnalyticsApi';

// As provided by SkyBet
export const TAGGERT_EMBED = '!function(){"use strict";var n=function(n,t){return Object.prototype.hasOwnProperty.call(t,n)},t="function"==typeof Object.assign?Object.assign:function(t){if(null==t)throw new TypeError("Cannot convert undefined or null to object");for(var e=Object(t),r=1,o=arguments.length;r<o;){var c=arguments[r];if(null!=c)for(var u in c)n(u,c)&&(e[u]=c[u]);r+=1}return e},e=function(n){return null!=n&&"object"==typeof n&&!0===n["@@functional/placeholder"]},r=function(n){return function t(r){return 0===arguments.length||e(r)?t:n.apply(this,arguments)}},o=function(n){return function t(o,c){switch(arguments.length){case 0:return t;case 1:return e(o)?t:r(function(t){return n(o,t)});default:return e(o)&&e(c)?t:e(o)?r(function(t){return n(t,c)}):e(c)?r(function(t){return n(o,t)}):n(o,c)}}}(function(n,e){return t({},n,e)});const c=(n,t,e)=>{const r=[],c=t=>{n.contentWindow.postMessage(t,e)};let u=!1;return n.addEventListener("load",()=>{u=!0,r.forEach(c)}),(n,e)=>{const a=o(e,{event:`${t}.${n}`});u?c(a):r.push(a)}},u=(n,t,e)=>{const r=n.createElement("iframe");return r.id="data-layer-iframe",r.sandbox="allow-scripts allow-same-origin",r.src=`${t}/tag-manager.html?consumer=${encodeURIComponent(e)}`,r.style.display="none",r};window.Taggert={report:((n,t)=>{const e=n.SIGNAL_CONSUMER||n.location.hostname,r=u(n.document,t,e);return document.body.appendChild(r),c(r,e,t)})(window,"https://www.bonne-terre-data-layer.com")}}();';

export default class SbgSignalAnalytics extends AnalyticsApi {
  constructor(options, store) {
    super("SBG Signal", "signal", options);

    this.getState = store.getState;
  }

  pageView(...args) {
    super.pageView(...args);
    this.trackDeviceId();
  }

  trackDeviceId() {
    const appBridgeReady = this.getState().common.auth.appBridgeReady || false;
    if (window.SkyBetAccount && appBridgeReady) {
      const appBridge = window.SkyBetAccount.getAppBridge();
      if (appBridge) {
        appBridge.trigger('getDeviceIDFA');
      }
    }
  }

  isSetUp() {
    return !!window.Taggert;
  }

  sendTracking(hitType, params) {
    window.Taggert.report(hitType, params);
  }
}




// WEBPACK FOOTER //
// ./utils/SbgSignalAnalytics.js